export default "__VITE_ASSET__0dad9f73__"